import React from 'react'
import './style.css'
import {Link} from 'react-router-dom'
import tm1 from '../../images/Aboutus/DrDaniel.webp'
import tm2 from '../../images/Aboutus/DrGudeta.webp'
import tm3 from '../../images/Aboutus/MedicalReceptionist.webp'
import tm4 from '../../images/Aboutus/TekabeBekeleManager.webp'
import tm5 from '../../images/Aboutus/MedicalReceptionist.webp'
import tm6 from '../../images/Aboutus/TekabeBekeleManager.webp'


const TeamSection = (props) => {

    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }

    return(
        <div  className={`volunteer-area section-padding ${props.addclass}`}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 offset-lg-3">
                        <div className="section-title section-title2 text-center">
                            <div className="thumb-text">
                                <span>Volunteer</span>
                            </div>
                            <h2>Our Great Volunteer || በጎ ፈቃደኞች</h2>
                            <p>Volunteers don’t get paid, not because they’re worthless, but because they’re priceless !</p>
                            <p>በጎ ፈቃደኞች የሚከፈሉት ዋጋ ስለሌላቸው ሳይሆን ዋጋ ስለሌላቸው ነው። ዋጋቸው ሊገመት አይችልም።</p>
                        </div>
                    </div>
                </div>
                <div className="volunteer-wrap">
                    <div className="row">
                        <div className="col col-lg-3 col-md-6 custom-grid col-12">
                            <div className="volunteer-item">
                                <div className="volunteer-img">
                                    <img src={tm1} alt="" />
                                </div>
                                <div className="volunteer-content">
                                    <h2><Link onClick={ClickHandler} to="/volunteer">Adriane Newby</Link></h2>
                                    <span>Volunteer</span>
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 custom-grid col-12">
                            <div className="volunteer-item">
                                <div className="volunteer-img">
                                    <img src={tm2} alt="" />
                                </div>
                                <div className="volunteer-content">
                                    <h2><Link onClick={ClickHandler} to="/volunteer">Allene Castaneda</Link></h2>
                                    <span>Volunteer</span>
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 custom-grid col-12">
                            <div className="volunteer-item">
                                <div className="volunteer-img">
                                    <img src={tm3} alt="" />
                                </div>
                                <div className="volunteer-content">
                                    <h2><Link onClick={ClickHandler} to="/volunteer">Malinda Willoughby</Link></h2>
                                    <span>Volunteer</span>
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 custom-grid col-12">
                            <div className="volunteer-item">
                                <div className="volunteer-img">
                                    <img src={tm4} alt="" />
                                </div>
                                <div className="volunteer-content">
                                    <h2><Link onClick={ClickHandler} to="/volunteer">Wilburn Hatfield</Link></h2>
                                    <span>Volunteer</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TeamSection;